import { Fragment, useEffect, useRef, useState } from "react";
import ViewAssessmentExamQuestion from "./ViewAssessmentExamQuestion";
import { FaCheck, FaTimes } from "react-icons/fa";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { useParams } from "react-router-dom";

const dummyExam = {
  subTopic: "Frontend Assessment",
  courseName: "React",
  totalMCQQuestions: 20,
  duration: 30,
};

const dummyQuestions = Array.from({ length: 20 }).map((_, i) => ({
  id: i + 1,
  question: `Sample assessment question ${i + 1}?`,
  isCorrectAnswer: i % 3 !== 0,
  isConfident: i % 2 === 0,
  answer: 2,
  options: [
    { id: 1, option: "Option A", isAnswer: false },
    { id: 2, option: "Option B", isAnswer: true },
    { id: 3, option: "Option C", isAnswer: false },
    { id: 4, option: "Option D", isAnswer: false },
  ],
}));


const ViewAssessmentExam = () => {
  const { id } = useParams(); 
  const [questions] = useState(dummyQuestions);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const scrollRef = useRef(null);
    const correctCount = questions.filter(q => q.isCorrectAnswer).length;
  const percent = (correctCount / questions.length) * 100;

  useEffect(() => {
    scrollRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
    });
  }, [selectedIndex]);

  return (
    <Fragment>
      <div className="w-full px-4 mt-4">
        <div className="hidden md:grid grid-cols-12 gap-4">

          {/* LEFT QUESTION LIST */}
          <div className="col-span-2 max-h-[82vh] overflow-y-auto space-y-2">
            {questions.map((q, i) => {
              const isActive = i === selectedIndex;

              return (
                <div
                  key={q.id}
                  ref={isActive ? scrollRef : null}
                  onClick={() => setSelectedIndex(i)}
                  className={`
                    cursor-pointer rounded-md py-3 text-center text-base border transition
                    ${
                      isActive
                        ? "bg-blue-100 dark:bg-blue-500 border-blue-500"
                        : "bg-slate-200 dark:bg-slate-800 border-slate-300 dark:border-slate-700"
                    }
                  `}
                >
                  {q.isCorrectAnswer ? (
                    <FaCheck className="inline mr-1 text-green-600" />
                  ) : (
                    <FaTimes className="inline mr-1 text-red-600" />
                  )}
                  <span className="text-black dark:text-gray-100">
                    Question {i + 1}
                  </span>
                </div>
              );
            })}
          </div>

          {/* RIGHT CONTENT */}
          <div className="col-span-10">

            {/* HEADER */}
            <div className="flex flex-wrap gap-6 items-center mb-12">

              {/* TIMER */}
              <div className="w-[120px] h-[120px] flex items-center justify-center rounded-full border-4 border-orange-400 text-orange-400 font-bold">
                00:30:00
              </div>

              {/* DETAILS */}
              <div className="text-sky-800 dark:text-slate-200">
                <div className=" font-semibold dark:font-normal">
                  Sub Topic : {dummyExam.subTopic}
                </div>

              </div>

              {/* RIGHT INFO */}
                <div className="ml-auto w-full md:w-1/3 flex flex-col items-end text-right">
                {/* PROGRESS */}
                <div className="flex items-center w-full mt-2">
                  <span className="mr-2 text-base">Completed</span>

                  <div className="flex-1 bg-gray-200 rounded h-2 mx-2">
                    <div
                      className="h-2 rounded bg-green-600"
                      style={{ width: `${percent}%` }}
                    />
                  </div>

                  <span className="text-base">
                    {correctCount}/{questions.length}
                  </span>
                </div>
              </div>
            </div>

            {/* QUESTION VIEW */}
            <ViewAssessmentExamQuestion
              index={selectedIndex}
              input={questions[selectedIndex]}
            />

            {/* NAVIGATION */}
            <div className="flex pt-6 items-center">
              {selectedIndex > 0 && (
                <button
                  onClick={() => setSelectedIndex((p) => p - 1)}
                  className="
                    flex items-center gap-2 px-4 py-2 rounded-md border
                    bg-slate-100 dark:bg-slate-800
                    border-slate-300 dark:border-slate-700
                    text-slate-700 dark:text-slate-200
                    hover:bg-slate-200 dark:hover:bg-slate-700
                    transition
                  "
                >
                  <ArrowLeft size={18} />
                  Previous
                </button>
              )}

              {selectedIndex < questions.length - 1 && (
                <button
                  onClick={() => setSelectedIndex((p) => p + 1)}
                  className="
                   ml-auto flex items-center gap-2 px-4 py-2 rounded-md
                    px-8 py-2 rounded-md border-slate-300 dark:border-slate-700 bg-[#0e3a46] text-white text-base
                  "
                >
                  Next
                  <ArrowRight size={18} />
                </button>
              )}
            </div>

          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default ViewAssessmentExam;